import axios from 'axios';

// Ensure cookies are sent with every request
axios.defaults.withCredentials = true;

// Inject x-location-id header from localStorage on every request
axios.interceptors.request.use((config) => {
  const locationId = localStorage.getItem('selectedLocationId');
  if (locationId) {
    config.headers['x-location-id'] = locationId;
  }
  return config;
});

// Global response interceptor: 401 redirect + Sentry error tracking
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config.url?.includes('/api/auth/') && !error.config.url?.includes('/api/booking/')) {
      window.location.href = '/login';
    }

    // Report API errors (4xx/5xx) to Sentry — skip:
    //  - Network errors with no response (transient connectivity, undebuggable)
    //  - All 401s: auth is binary in this app (logged in or not), so every 401
    //    means "session bad → redirect to login." The redirect above is the
    //    action; Sentry capture adds no signal.
    //  - 409s on /api/booking/: backend's expected "this job is no longer
    //    bookable / already taken" rejection, surfaced to the user in the UI.
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isExpectedBooking409 = status === 409 && url.includes('/api/booking/');
    if (status >= 400 && status !== 401 && !isExpectedBooking409) {
      import('@sentry/react').then((Sentry) => {
        Sentry.captureMessage(`API ${error.config?.method?.toUpperCase()} ${error.config?.url} → ${error.response.status}`, {
          level: error.response.status >= 500 ? 'error' : 'warning',
          extra: {
            status: error.response.status,
            url: error.config?.url,
            method: error.config?.method,
            responseData: error.response.data,
          },
          tags: { type: 'api_error', status: String(error.response.status) },
        });
      }).catch(() => {});
    }

    return Promise.reject(error);
  }
);

export default axios;
